/* Stylesheet */

.table_options {
  padding: 8px 12px 8px 21px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--ion-gradient-light);

  .label {
    display: flex;
    align-items: center;

    .icon {
      margin: 0px 12px 0px 0px;
      height: 21px;
      width: 21px;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .download_button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: var(--ion-color-medium, #92949c);
    font-size: 20px;
    line-height: 1;
    transition: color 0.2s ease, opacity 0.2s ease;

    &:hover:not(:disabled) {
      color: var(--ion-color-primary, #3880ff);
    }

    &.download_button_loading {
      opacity: 0.4;
      cursor: wait;
    }
  }
}
